import React from 'react'
import { SVGIconProps } from '../types'
const SvgScatterPlot = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <circle cx={7} cy={14} r={3} />
    <circle cx={11} cy={6} r={3} />
    <circle cx={16.6} cy={17.6} r={3} />
  </svg>
)
export default SvgScatterPlot
